(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-logo"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(root) {
      root = root || document;
      
      var section = root.querySelector('.carousel-logo-section');
      if (!section) return;

      var track = section.querySelector('[data-carousel-track]');
      if (!track) return;

      // Only initialize if not already initialized
      if (track.dataset.initialized === 'true') return;
      track.dataset.initialized = 'true';

      // Ensure smooth animation
      var items = track.querySelectorAll('.carousel-logo-item');
      if (items.length === 0) return;

      // Reset animation if needed
      track.style.animation = 'none';
      requestAnimationFrame(function() {
        track.style.animation = '';
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initCarousel(document);
      });
    } else {
      initCarousel(document);
    }

    // Shopify Theme Editor support
    document.addEventListener('shopify:section:load', function(event) {
      initCarousel(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    function initCartQty() {
      document.querySelectorAll('.cart-ticket-qty').forEach(function(wrap) {
        var minus = wrap.querySelector('.cart-td-minus');
        var plus = wrap.querySelector('.cart-td-plus');
        var input = wrap.querySelector('.cart-td-qty-value');
        if (!minus || !plus || !input) return;
        var row = wrap.closest('.cart-ticket-layout');
        var itemKey = row && row.getAttribute('data-key');
        if (!itemKey) return;

        var qtyDebounceTimer = null;
        var qtyPending = false;

        function updateQty(newQty) {
          if (newQty < 0) return;
          if (qtyPending) return;
          qtyPending = true;
          minus.disabled = true;
          plus.disabled = true;
          input.disabled = true;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: itemKey, quantity: newQty })
          })
            .then(function(res) {
              if (!res.ok) throw new Error('Cart update failed');
              return res.json();
            })
            .then(function() { return updateTotalFromCart(); })
            .then(function() {
              qtyPending = false;
              minus.disabled = false;
              plus.disabled = false;
              input.disabled = false;
            })
            .catch(function() {
              qtyPending = false;
              minus.disabled = false;
              plus.disabled = false;
              input.disabled = false;
              window.location.reload();
            });
        }

        function scheduleQtyUpdate() {
          if (qtyDebounceTimer) clearTimeout(qtyDebounceTimer);
          qtyDebounceTimer = setTimeout(function() {
            qtyDebounceTimer = null;
            var v = parseInt(input.value, 10) || 0;
            if (v < 0) {
              input.value = 0;
              v = 0;
            }
            updateQty(v);
          }, 100);
        }

        minus.addEventListener('click', function(e) {
          e.preventDefault();
          if (qtyPending) return;
          var v = parseInt(input.value, 10) || 0;
          if (v <= 0) return;
          var newQty = v - 1;
          input.value = newQty;
          scheduleQtyUpdate();
        });
        plus.addEventListener('click', function(e) {
          e.preventDefault();
          if (qtyPending) return;
          var v = parseInt(input.value, 10) || 0;
          var newQty = (v < 0 ? 0 : v) + 1;
          input.value = newQty;
          scheduleQtyUpdate();
        });
        input.addEventListener('change', function() {
          if (qtyPending) return;
          var v = parseInt(input.value, 10) || 0;
          if (v < 0) {
            input.value = 0;
            v = 0;
          }
          input.value = v;
          scheduleQtyUpdate();
        });
      });
    }

    function formatMoney(cents) {
      var sectionEl = document.querySelector('.cart-section');
      var format = sectionEl && sectionEl.getAttribute('data-money-format');
      if (!format) return (cents / 100).toFixed(2);
      var amount = cents / 100;
      var num = amount.toFixed(2);
      var numNoDec = Math.round(amount);
      var numComma = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, numComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, numNoDec.toLocaleString())
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(numNoDec))
        .replace(/\{\{\s*amount\s*\}\}/g, num);
    }

    function updateCartTotal(totalPrice) {
      var sectionEl = document.querySelector('.cart-section');
      if (!sectionEl) return;
      var totalEl = sectionEl.querySelector('.cart-total-price');
      if (totalEl) totalEl.textContent = formatMoney(totalPrice);
      var footer = sectionEl.querySelector('.cart-footer');
      if (footer) footer.setAttribute('data-cart-total', totalPrice);
    }

    function updateTotalFromCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartTotal(cart.total_price);
        });
    }

    function reorderCartRowsToFirstAddedFirst(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return;
      var orderedKeys = cart.items.slice().reverse().map(function(i) { return i.key; });
      reorderCartRowsByKeys(orderedKeys);
    }

    function reorderCartRowsByKeys(orderedKeys) {
      var container = document.querySelector('.cart-items');
      if (!container || !orderedKeys || orderedKeys.length === 0) return;
      var rowMap = {};
      container.querySelectorAll('.cart-ticket-layout').forEach(function(row) {
        var k = row.getAttribute('data-key');
        if (k) rowMap[k] = row;
      });
      var fragment = document.createDocumentFragment();
      var divider = document.createElement('div');
      divider.className = 'cart-divider';
      orderedKeys.forEach(function(key, i) {
        var row = rowMap[key];
        if (row) {
          fragment.appendChild(row);
          if (i < orderedKeys.length - 1) fragment.appendChild(divider.cloneNode(true));
        }
      });
      container.innerHTML = '';
      container.appendChild(fragment);
    }

    function initCartPage() {
      initCartQty();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          reorderCartRowsToFirstAddedFirst(cart);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartPage);
    } else {
      initCartPage();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  function initCountdown() {
    const timer = document.getElementById('countdown-timer');
    if (!timer) return;
    
    const targetDate = timer.dataset.targetDate;
    if (!targetDate) return;
    
    const target = new Date(targetDate).getTime();
    
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = target - now;
      
      if (distance < 0) {
        document.querySelector('.countdown-days').textContent = '00';
        document.querySelector('.countdown-hours').textContent = '00';
        document.querySelector('.countdown-minutes').textContent = '00';
        return;
      }
      
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      
      document.querySelector('.countdown-days').textContent = String(days).padStart(2, '0');
      document.querySelector('.countdown-hours').textContent = String(hours).padStart(2, '0');
      document.querySelector('.countdown-minutes').textContent = String(minutes).padStart(2, '0');
    }
    
    updateCountdown();
    setInterval(updateCountdown, 60000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    initCountdown();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["festival-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mapEls = document.querySelectorAll('.festival-map-main-map--svg[data-venue-map-url]');
    if (!mapEls.length) return;

    function escapeId(id) {
      if (window.CSS && CSS.escape) return CSS.escape(id);
      return String(id).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
    }

    mapEls.forEach(function (mapEl) {
      var isHidden = window.getComputedStyle(mapEl).display === 'none';
      if (isHidden) return;

      var url = mapEl.getAttribute('data-venue-map-url');
      var vendorsScript = mapEl.querySelector('script.festival-map-vendors-json');
      var vendors = [];
      try {
        vendors = vendorsScript && vendorsScript.textContent ? JSON.parse(vendorsScript.textContent.trim()) : [];
      } catch (e) {
        return;
      }

      var tooltipEl = mapEl.querySelector('.festival-map-venue-tooltip');
      if (!tooltipEl) return;

      var vendorsById = {};
      vendors.forEach(function (v) {
        // Prefer the first block for a given id (e.g. 'TINY' text over 'TINY' icon)
        if (!vendorsById[v.id]) {
          vendorsById[v.id] = v;
        }
      });

      var badgeTypes = ['brewer', 'deep_green', 'food', 'red_wine', 'food_truck', 'registration', 'festival_bar', 'tiny', 'mahogany', 'tiny_icon'];
      function clearBadgeClass() {
        badgeTypes.forEach(function (t) { tooltipEl.classList.remove('festival-map-venue-tooltip--' + t); });
      }

      var sectionEl = mapEl.closest('section');
      var isSimpleMobileSvgMode = isMobileMapViewport() && mapEl.classList.contains('festival-map-main-map--svg-mobile');
      var highlightedLegendItem = null;
      var highlightedVenueNode = null;
      var activeVenueId = null;
      var svgEl = null;
      var clickedVenueId = null;

      var didDragThisSession = false;
      var dragStartX, dragStartY, dragStartScrollLeft, dragStartScrollTop, isDragging = false;
      var svgScale = 1;
      var svgMinScale = 1;
      var svgMaxScale = 3;
      var svgTx = 0;
      var svgTy = 0;
      var svgPointers = new Map();
      var svgStartDist = 0;
      var svgStartScale = 1;
      var svgPanStartX = 0;
      var svgPanStartY = 0;
      var svgPanStartTx = 0;
      var svgPanStartTy = 0;

      function isMobileMapViewport() {
        return window.matchMedia('(max-width: 767px)').matches;
      }

      function setupSvgZoomPan(svg) {
        if (!isMobileMapViewport()) return;
        if (!svg) return;
        // Mobile initial position (0 = left/top edge, 50 = center, 100 = right/bottom edge)
        var initialMobileXPercent = 20;
        var initialMobileYPercent = 50;

        var mapWrapper = mapEl.closest('.festival-map-map-wrapper');
        if (mapWrapper) {
          mapWrapper.style.overflow = 'hidden';
          mapWrapper.style.touchAction = 'none';
        }
        mapEl.style.overflow = 'hidden';
        mapEl.style.touchAction = 'none';
        if (mapWrapper) {
          mapWrapper.scrollLeft = 0;
          mapWrapper.scrollTop = 0;
        }
        svg.style.touchAction = 'none';
        svg.style.transformOrigin = '0 0';

        function getDist(a, b) {
          var dx = a.clientX - b.clientX;
          var dy = a.clientY - b.clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        function getContainerSize() {
          return (mapWrapper || mapEl).getBoundingClientRect();
        }

        function getSvgNaturalSize() {
          return {
            w: svg.clientWidth || svg.getBoundingClientRect().width / Math.max(svgScale, 0.001),
            h: svg.clientHeight || svg.getBoundingClientRect().height / Math.max(svgScale, 0.001)
          };
        }

        function clampSvgPan() {
          var container = getContainerSize();
          var nat = getSvgNaturalSize();
          var scaledW = nat.w * svgScale;
          var scaledH = nat.h * svgScale;
          var minX = container.width - scaledW;
          var maxX = 0;
          var minY = container.height - scaledH;
          var maxY = 0;

          // Keep map centered when scaled content is smaller than viewport.
          if (scaledW <= container.width) {
            minX = (container.width - scaledW) / 2;
            maxX = minX;
          }
          if (scaledH <= container.height) {
            minY = (container.height - scaledH) / 2;
            maxY = minY;
          }

          if (svgTx > maxX) svgTx = maxX;
          if (svgTx < minX) svgTx = minX;
          if (svgTy > maxY) svgTy = maxY;
          if (svgTy < minY) svgTy = minY;
        }

        function applySvgTransform() {
          clampSvgPan();
          svg.style.transform = 'matrix(' + svgScale + ',0,0,' + svgScale + ',' + svgTx + ',' + svgTy + ')';
        }

        function centerSvgTransform() {
          var container = getContainerSize();
          var nat = getSvgNaturalSize();
          var scaledW = nat.w * svgScale;
          var scaledH = nat.h * svgScale;
          var minX = container.width - scaledW;
          var maxX = 0;
          var minY = container.height - scaledH;
          var maxY = 0;
          var xRatio = Math.max(0, Math.min(1, initialMobileXPercent / 100));
          var yRatio = Math.max(0, Math.min(1, initialMobileYPercent / 100));

          if (scaledW <= container.width) {
            svgTx = (container.width - scaledW) / 2;
          } else {
            // 0% = left, 50% = center, 100% = right
            svgTx = maxX - (maxX - minX) * xRatio;
          }

          if (scaledH <= container.height) {
            svgTy = (container.height - scaledH) / 2;
          } else {
            // 0% = top, 50% = center, 100% = bottom
            svgTy = maxY - (maxY - minY) * yRatio;
          }
        }

        mapEl.addEventListener('touchstart', function (ev) {
          if (!isMobileMapViewport()) return;
          ev.preventDefault();
          if (ev.touches.length === 1) {
            svgPanStartX = ev.touches[0].clientX;
            svgPanStartY = ev.touches[0].clientY;
            svgPanStartTx = svgTx;
            svgPanStartTy = svgTy;
            didDragThisSession = false;
          } else if (ev.touches.length === 2) {
            svgStartDist = getDist(ev.touches[0], ev.touches[1]);
            svgStartScale = svgScale;
            svgPanStartX = (ev.touches[0].clientX + ev.touches[1].clientX) / 2;
            svgPanStartY = (ev.touches[0].clientY + ev.touches[1].clientY) / 2;
            svgPanStartTx = svgTx;
            svgPanStartTy = svgTy;
          }
        }, { passive: false });

        mapEl.addEventListener('touchmove', function (ev) {
          if (!isMobileMapViewport()) return;
          ev.preventDefault();
          if (ev.touches.length === 2) {
            var d = getDist(ev.touches[0], ev.touches[1]);
            if (svgStartDist > 0) {
              svgScale = Math.max(svgMinScale, Math.min(svgMaxScale, svgStartScale * (d / svgStartDist)));
            }
            var cx = (ev.touches[0].clientX + ev.touches[1].clientX) / 2;
            var cy = (ev.touches[0].clientY + ev.touches[1].clientY) / 2;
            svgTx = svgPanStartTx + (cx - svgPanStartX);
            svgTy = svgPanStartTy + (cy - svgPanStartY);
            applySvgTransform();
            didDragThisSession = true;
            return;
          }
          if (ev.touches.length === 1) {
            svgTx = svgPanStartTx + (ev.touches[0].clientX - svgPanStartX);
            svgTy = svgPanStartTy + (ev.touches[0].clientY - svgPanStartY);
            applySvgTransform();
            didDragThisSession = true;
          }
        }, { passive: false });

        mapEl.addEventListener('touchend', function (ev) {
          if (!isMobileMapViewport()) return;
          if (ev.touches.length === 0) {
            setTimeout(function () { didDragThisSession = false; }, 80);
          }
          if (ev.touches.length === 1) {
            svgPanStartX = ev.touches[0].clientX;
            svgPanStartY = ev.touches[0].clientY;
            svgPanStartTx = svgTx;
            svgPanStartTy = svgTy;
          }
        }, { passive: true });

        svgScale = 1.2;
        centerSvgTransform();
        applySvgTransform();

        function recenterSvg() {
          centerSvgTransform();
          applySvgTransform();
        }

        requestAnimationFrame(function () {
          recenterSvg();
          requestAnimationFrame(recenterSvg);
        });
        setTimeout(recenterSvg, 120);

        window.addEventListener('resize', function () {
          if (!isMobileMapViewport()) return;
          recenterSvg();
        });
      }

      function isTabletOrSmallerViewport() {
        return window.matchMedia('(max-width: 1024px)').matches;
      }

      function resolveLegendItemForVenue(venueId) {
        if (!sectionEl) return null;
        var sel = '.festival-map-vendor-item[data-venue-id="' + venueId + '"]';
        var items = sectionEl.querySelectorAll(sel);
        if (!items.length) return null;
        if (items.length === 1) return items[0];
        var gridSel = isTabletOrSmallerViewport() ? '.festival-map-legend-grid--mobile' : '.festival-map-legend-grid--desktop';
        var grid = sectionEl.querySelector(gridSel);
        if (grid) {
          var found = grid.querySelector(sel);
          if (found) return found;
        }
        return items[0];
      }

      function setLegendActive(venueId) {
        if (sectionEl) {
          sectionEl.querySelectorAll('.festival-map-vendor-item.festival-map-vendor-item--tooltip-active').forEach(function (el) {
            el.classList.remove('festival-map-vendor-item--tooltip-active');
          });
        }
        highlightedLegendItem = null;
        if (!sectionEl || !venueId) return;
        var legendItem = resolveLegendItemForVenue(venueId);
        if (!legendItem) return;
        legendItem.classList.add('festival-map-vendor-item--tooltip-active');
        highlightedLegendItem = legendItem;
      }

      function setVenueActive(node) {
        if (highlightedVenueNode) highlightedVenueNode.classList.remove('is-active');
        highlightedVenueNode = null;
        if (!node) return;
        node.classList.add('is-active');
        highlightedVenueNode = node;
      }

      function positionTooltip(x, y) {
        var mapRect = mapEl.getBoundingClientRect();
        var rect = tooltipEl.getBoundingClientRect();
        var px = x - mapRect.left;
        var py = y - mapRect.top;
        var off = 12;
        var left;
        var top;

        if (isTabletOrSmallerViewport() && highlightedVenueNode) {
          var boothCircle = highlightedVenueNode.querySelector('.cls-18') || highlightedVenueNode.querySelector('.cls-20');
          var nodeR = boothCircle ? boothCircle.getBoundingClientRect() : highlightedVenueNode.getBoundingClientRect();
          var nodeLeft = nodeR.left - mapRect.left;
          var nodeRight = nodeR.right - mapRect.left;
          var nodeTop = nodeR.top - mapRect.top;
          var nodeBottom = nodeR.bottom - mapRect.top;
          var nodeCenterY = (nodeTop + nodeBottom) / 2;
          var gap = 10;
          if (nodeRight + gap + rect.width <= mapRect.width - 4) {
            left = nodeRight + gap;
          } else if (nodeLeft - gap - rect.width >= 4) {
            left = nodeLeft - rect.width - gap;
          } else {
            left = Math.max(4, Math.min(px - rect.width / 2, mapRect.width - rect.width - 4));
          }
          top = nodeCenterY - rect.height / 2;
          if (top < 4) top = 4;
          if (top + rect.height > mapRect.height - 4) top = mapRect.height - rect.height - 4;
        } else {
          left = px + off;
          top = py + off;
          if (left + rect.width > mapRect.width - 10) left = px - rect.width - off;
          if (top + rect.height > mapRect.height - 10) top = py - rect.height - off;
          if (left < 10) left = 10;
          if (top < 10) top = 10;
        }

        tooltipEl.style.left = left + 'px';
        tooltipEl.style.top = top + 'px';
      }

      function updateTooltipPositionFromNode() {
        if (!tooltipEl.classList.contains('is-visible') || !highlightedVenueNode) return;
        var boothCircle = highlightedVenueNode.querySelector('.cls-18') || highlightedVenueNode.querySelector('.cls-20');
        var r = boothCircle ? boothCircle.getBoundingClientRect() : highlightedVenueNode.getBoundingClientRect();
        var x = r.left + r.width / 2;
        var y = r.top + r.height / 2;
        positionTooltip(x, y);
      }

      function showTooltip(label, badgeType, venueId, x, y) {
        clearBadgeClass();
        if (badgeType) tooltipEl.classList.add('festival-map-venue-tooltip--' + badgeType);
        tooltipEl.textContent = label;
        tooltipEl.hidden = false;
        tooltipEl.classList.add('is-visible');
        activeVenueId = venueId || null;
        setLegendActive(activeVenueId);
        positionTooltip(x, y);
      }

      function hideTooltip() {
        if (clickedVenueId === activeVenueId) return;
        tooltipEl.classList.remove('is-visible');
        clearBadgeClass();
        tooltipEl.hidden = true;
        activeVenueId = null;
        clickedVenueId = null;
        if (sectionEl) {
          sectionEl.querySelectorAll('.festival-map-vendor-item.festival-map-vendor-item--tooltip-active').forEach(function (el) {
            el.classList.remove('festival-map-vendor-item--tooltip-active');
          });
        }
        highlightedLegendItem = null;
        if (highlightedVenueNode) {
          highlightedVenueNode.classList.remove('is-active');
          highlightedVenueNode = null;
        }
      }

      var svgReady = fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (svgText) {
          var wrap = document.createElement('div');
          wrap.innerHTML = svgText.trim();
          var svg = wrap.querySelector('svg');
          if (!svg) return null;
          svg.setAttribute('aria-hidden', 'true');
          mapEl.insertBefore(svg, tooltipEl);
          svgEl = svg;
          setupSvgZoomPan(svgEl);
          if (isSimpleMobileSvgMode) {
            tooltipEl.hidden = true;
            tooltipEl.classList.remove('is-visible');
            return svg;
          }

          vendors.forEach(function (v) {
            var node = svg.querySelector('#' + escapeId(v.id));
            if (!node) return;
            node.setAttribute('data-venue-id', v.id);
            node.setAttribute('role', 'button');
            node.setAttribute('aria-label', v.label);

            node.addEventListener('mouseenter', function (ev) {
              setVenueActive(node);
              showTooltip(v.label, v.badgeType || '', v.id, ev.clientX, ev.clientY);
            });
            node.addEventListener('mousemove', function (ev) {
              if (tooltipEl.classList.contains('is-visible')) positionTooltip(ev.clientX, ev.clientY);
            });
            node.addEventListener('mouseleave', hideTooltip);
            
            node.addEventListener('click', function (ev) {
              if (didDragThisSession) {
                ev.preventDefault();
                ev.stopPropagation();
                return;
              }
              ev.stopPropagation();
              if (clickedVenueId === v.id && tooltipEl.classList.contains('is-visible')) {
                clickedVenueId = null;
                hideTooltip();
                return;
              }
              clickedVenueId = v.id;
              setVenueActive(node);
              var boothCircle = node.querySelector('.cls-18') || node.querySelector('.cls-20');
              var r = boothCircle ? boothCircle.getBoundingClientRect() : node.getBoundingClientRect();
              var x = r.left + r.width / 2;
              var y = r.top + r.height / 2;
              showTooltip(v.label, v.badgeType || '', v.id, x, y);
            });
          });

          return svg;
        })
        .catch(function () { return null; });

      if (sectionEl && !isSimpleMobileSvgMode) {
        var legendItems = sectionEl.querySelectorAll('.festival-map-vendor-item[data-venue-id]');
        legendItems.forEach(function (item) {
          function activateFromLegend() {
            var venueId = item.getAttribute('data-venue-id');
            if (!venueId) return;
            if (clickedVenueId === venueId && tooltipEl.classList.contains('is-visible')) {
              clickedVenueId = null;
              hideTooltip();
              return;
            }
            clickedVenueId = venueId;
            var v = vendorsById[venueId];
            if (!v) return;

            mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            svgReady.then(function () {
              if (!svgEl) return;
              var node = svgEl.querySelector('#' + escapeId(venueId));
              if (!node) return;
              setVenueActive(node);
              function showAtVenue() {
                var boothCircle = node.querySelector('.cls-18') || node.querySelector('.cls-20');
                var r = boothCircle ? boothCircle.getBoundingClientRect() : node.getBoundingClientRect();
                var x = r.left + r.width / 2;
                var y = r.top + r.height / 2;
                showTooltip(v.label, v.badgeType || '', venueId, x, y);
              }
              function runAfterScroll() {
                requestAnimationFrame(function () {
                  requestAnimationFrame(showAtVenue);
                });
              }
              var scrollEndTimeout = setTimeout(runAfterScroll, 500);
              window.addEventListener('scrollend', function onScrollEnd() {
                clearTimeout(scrollEndTimeout);
                runAfterScroll();
              }, { once: true });
            });
          }

          item.addEventListener('click', function () { activateFromLegend(); });
          item.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
              ev.preventDefault();
              activateFromLegend();
            }
          });
        });
      }

      if (!isSimpleMobileSvgMode) {
        window.addEventListener('scroll', updateTooltipPositionFromNode, { passive: true });
        window.addEventListener('resize', updateTooltipPositionFromNode);
        mapEl.addEventListener('scroll', updateTooltipPositionFromNode, { passive: true });
      }
    });
  })();

  (function () {
    function isMobileViewport() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function centerMapScroll() {
      if (!isMobileViewport()) return;
      document.querySelectorAll('.festival-map-map-wrapper').forEach(function (wrapper) {
        if (wrapper.querySelector('.festival-map-main-map--svg')) return;
        var maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
        if (maxScrollLeft > 0) {
          wrapper.scrollLeft = Math.round(maxScrollLeft / 2);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        requestAnimationFrame(centerMapScroll);
      });
    } else {
      requestAnimationFrame(centerMapScroll);
    }

    window.addEventListener('resize', function () {
      requestAnimationFrame(centerMapScroll);
    });
  })();

  (function () {
    function isMobileViewport() {
      return window.matchMedia('(max-width: 767px)').matches;
    }
    if (!isMobileViewport()) return;

    document.querySelectorAll('.festival-map-map-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('.festival-map-main-map--svg')) return;
      var image = wrapper.querySelector('img.festival-map-main-map');
      if (!image) return;

      wrapper.classList.add('festival-map-map-wrapper--zoomable');

      var scale = 1;
      var minScale = 1;
      var maxScale = 2.2;
      var tx = 0;
      var ty = 0;
      var pointers = new Map();
      var startDist = 0;
      var startScale = 1;
      var startTx = 0;
      var startTy = 0;
      var startX = 0;
      var startY = 0;

      function clamp() {
        var rect = wrapper.getBoundingClientRect();
        var imgRect = image.getBoundingClientRect();
        var halfX = Math.max(0, (imgRect.width - rect.width) / 2);
        var halfY = Math.max(0, (imgRect.height - rect.height) / 2);
        if (tx > halfX) tx = halfX;
        if (tx < -halfX) tx = -halfX;
        if (ty > halfY) ty = halfY;
        if (ty < -halfY) ty = -halfY;
      }

      function apply() {
        clamp();
        image.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
        image.style.transformOrigin = 'center center';
      }

      function getDist(a, b) {
        var dx = a.clientX - b.clientX;
        var dy = a.clientY - b.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      wrapper.addEventListener('pointerdown', function (ev) {
        if (wrapper.setPointerCapture) {
          try { wrapper.setPointerCapture(ev.pointerId); } catch (e) {}
        }
        pointers.set(ev.pointerId, { clientX: ev.clientX, clientY: ev.clientY });
        if (pointers.size === 1) {
          startX = ev.clientX;
          startY = ev.clientY;
          startTx = tx;
          startTy = ty;
          wrapper.classList.add('festival-map-map-wrapper--grabbing');
        } else if (pointers.size === 2) {
          var p = Array.from(pointers.values());
          startDist = getDist(p[0], p[1]);
          startScale = scale;
        }
        ev.preventDefault();
      });

      wrapper.addEventListener('pointermove', function (ev) {
        if (!pointers.has(ev.pointerId)) return;
        pointers.set(ev.pointerId, { clientX: ev.clientX, clientY: ev.clientY });

        if (pointers.size === 2) {
          var p = Array.from(pointers.values());
          var dist = getDist(p[0], p[1]);
          if (startDist > 0) {
            scale = Math.max(minScale, Math.min(maxScale, startScale * (dist / startDist)));
            apply();
            ev.preventDefault();
          }
          return;
        }

        if (pointers.size === 1) {
          tx = startTx + (ev.clientX - startX);
          ty = startTy + (ev.clientY - startY);
          apply();
          ev.preventDefault();
        }
      }, { passive: false });

      function endPointer(ev) {
        pointers.delete(ev.pointerId);
        if (pointers.size === 0) {
          wrapper.classList.remove('festival-map-map-wrapper--grabbing');
        }
        if (scale <= 1) {
          scale = 1;
          apply();
        }
      }

      wrapper.addEventListener('pointerup', endPointer);
      wrapper.addEventListener('pointercancel', endPointer);
      wrapper.addEventListener('pointerleave', endPointer);

      var touchStartDist = 0;
      var touchStartScale = 1;
      var touchStartTx = 0;
      var touchStartTy = 0;
      var touchStartX = 0;
      var touchStartY = 0;

      wrapper.addEventListener('touchstart', function (ev) {
        if (ev.touches.length === 1) {
          touchStartX = ev.touches[0].clientX;
          touchStartY = ev.touches[0].clientY;
          touchStartTx = tx;
          touchStartTy = ty;
          wrapper.classList.add('festival-map-map-wrapper--grabbing');
        } else if (ev.touches.length === 2) {
          var t1 = ev.touches[0];
          var t2 = ev.touches[1];
          touchStartDist = getDist(t1, t2);
          touchStartScale = scale;
        }
      }, { passive: true });

      wrapper.addEventListener('touchmove', function (ev) {
        if (ev.touches.length === 2) {
          var t1 = ev.touches[0];
          var t2 = ev.touches[1];
          var d = getDist(t1, t2);
          if (touchStartDist > 0) {
            scale = Math.max(minScale, Math.min(maxScale, touchStartScale * (d / touchStartDist)));
            apply();
            ev.preventDefault();
          }
          return;
        }
        if (ev.touches.length === 1) {
          tx = touchStartTx + (ev.touches[0].clientX - touchStartX);
          ty = touchStartTy + (ev.touches[0].clientY - touchStartY);
          apply();
          ev.preventDefault();
        }
      }, { passive: false });

      wrapper.addEventListener('touchend', function () {
        if (scale < 1) scale = 1;
        apply();
        wrapper.classList.remove('festival-map-map-wrapper--grabbing');
      }, { passive: true });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.querySelector('.nav-toggle');
  const navLinks = document.querySelector('.nav-links');

  function closeNavDropdowns() {
    document.querySelectorAll('.nav-item--has-dropdown.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var btn = item.querySelector('.nav-dropdown-toggle');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  if (toggle && navLinks) {
    toggle.addEventListener('click', function () {
      navLinks.classList.toggle('active');
      var isActive = navLinks.classList.contains('active');
      toggle.textContent = isActive ? '✕' : '☰';
      if (!isActive) closeNavDropdowns();
    });
  }

  document.querySelectorAll('.nav-dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var item = btn.closest('.nav-item--has-dropdown');
      if (!item) return;
      document.querySelectorAll('.nav-item--has-dropdown').forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var ob = other.querySelector('.nav-dropdown-toggle');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        }
      });
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
  const toggle = document.querySelector(".nav-toggle");
  const navLinks = document.querySelector(".nav-links");

  if (toggle && navLinks) {
    toggle.addEventListener("click", () => {
      navLinks.classList.toggle("active");
      toggle.textContent = navLinks.classList.contains("active") ? "✕" : "☰";
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var overlay = document.querySelector('[data-homepage-popup]');
    if (!overlay) return;

    var delay = parseInt(overlay.getAttribute('data-popup-delay') || '1', 10) * 1000;
    var sessionKey = 'homepage_popup_closed';

    function closePopup() {
      overlay.setAttribute('hidden', '');
      overlay.classList.remove('is-visible');
      try {
        sessionStorage.setItem(sessionKey, '1');
      } catch (e) {}
    }

    function showPopup() {
      overlay.removeAttribute('hidden');
      overlay.classList.add('is-visible');
    }

    try {
      if (sessionStorage.getItem(sessionKey)) return;
    } catch (e) {}

    setTimeout(showPopup, delay);

    overlay.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  function initGallery() {
    const thumbnails = document.querySelectorAll('.thumb img');
    const mainImage = document.getElementById('gallery-main-image');
    const prevBtn = document.querySelector('.gallery-section .nav-btn.prev');
    const nextBtn = document.querySelector('.gallery-section .nav-btn.next');
    
    if (!thumbnails.length || !mainImage) return;
    
    let currentIndex = 0;
    const images = Array.from(thumbnails).map(img => img.dataset.full || img.src);
    
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        mainImage.src = images[index];
        currentIndex = index;
        updateThumbnails();
      });
    });
    
    function updateThumbnails() {
      thumbnails.forEach((thumb, index) => {
        thumb.style.filter = index === currentIndex ? 'grayscale(0%)' : 'grayscale(100%)';
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        mainImage.src = images[currentIndex];
        updateThumbnails();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % images.length;
        mainImage.src = images[currentIndex];
        updateThumbnails();
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.photo-grid-section').forEach(function (sec) {
    var dlg = sec.querySelector('.photo-grid-lightbox');
    var big = dlg.querySelector('img');
    sec.querySelectorAll('.photo-grid-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        big.src = btn.dataset.full;
        big.alt = btn.querySelector('img').alt;
        dlg.showModal();
      });
    });
    dlg.addEventListener('click', function () { dlg.close(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ticket-details"] && !Shopify.designMode) return;
  try {
    
  function initTicketDetailsQty() {
    var qtyContainers = document.querySelectorAll('.ticket-details-qty');
    qtyContainers.forEach(function (container) {
      var minusBtn = container.querySelector('.td-minus');
      var plusBtn = container.querySelector('.td-plus');
      var input = container.querySelector('.td-qty-value');
      if (!minusBtn || !plusBtn || !input) return;
      minusBtn.addEventListener('click', function () {
        var currentVal = parseInt(input.value, 10) || 1;
        if (currentVal > 1) input.value = currentVal - 1;
      });
      plusBtn.addEventListener('click', function () {
        var currentVal = parseInt(input.value, 10) || 1;
        input.value = currentVal + 1;
      });
    });
  }

  function initTicketDetailsVariant() {
    document.querySelectorAll('.ticket-details-purchase').forEach(function (purchase) {
      var optionsRoot = purchase.querySelector('.ticket-details-options');
      if (!optionsRoot) return;
      var scriptEl = purchase.querySelector('.ticket-details-variants-json');
      var variants = [];
      if (scriptEl) {
        try {
          variants = JSON.parse(scriptEl.textContent);
        } catch (e) {}
      }
      var priceEl = purchase.querySelector('.ticket-details-price');
      var form = purchase.querySelector('form[action*="/cart/add"]') || purchase.querySelector('form');
      var hiddenId = form ? form.querySelector('input[name="id"]') : null;
      if (!priceEl || !hiddenId) return;

      var option1Group = purchase.querySelector('.ticket-details-option1');
      var option2Group = purchase.querySelector('.ticket-details-option2');

      function getSelectedOption1() {
        if (!option1Group) return null;
        var btn = option1Group.querySelector('.ticket-details-variant-btn--selected');
        return btn ? btn.getAttribute('data-option-value') : null;
      }
      function getSelectedOption2() {
        if (!option2Group) return null;
        var btn = option2Group.querySelector('.ticket-details-variant-btn--selected');
        return btn ? btn.getAttribute('data-option-value') : null;
      }
      function findVariant(opt1, opt2) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.option1 === opt1 && (opt2 === undefined || v.option2 === opt2)) return v;
        }
        return null;
      }
      function setVariant(variant) {
        if (!variant) return;
        hiddenId.value = variant.id;
        priceEl.textContent = variant.price_formatted;
        priceEl.setAttribute('data-unit-price', variant.price);
      }
      function updateOption2Visibility(selectedOption1) {
        if (!option2Group) return;
        var validOption2 = [];
        variants.forEach(function (v) {
          if (v.option1 === selectedOption1 && validOption2.indexOf(v.option2) === -1) validOption2.push(v.option2);
        });
        option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          var show = validOption2.indexOf(val) !== -1;
          btn.style.display = show ? '' : 'none';
          if (!show) {
            btn.classList.remove('ticket-details-variant-btn--selected');
            btn.removeAttribute('aria-pressed');
          }
        });
      }
      function selectFirstOption2(selectedOption1) {
        if (!option2Group) {
          var v = findVariant(selectedOption1);
          if (v) setVariant(v);
          return;
        }
        var firstBtn = null;
        option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
          if (getComputedStyle(b).display !== 'none') firstBtn = firstBtn || b;
        });
        if (!firstBtn) return;
        var opt2 = firstBtn.getAttribute('data-option-value');
        var v = findVariant(selectedOption1, opt2);
        if (v) {
          option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
            b.classList.remove('ticket-details-variant-btn--selected');
            b.removeAttribute('aria-pressed');
          });
          firstBtn.classList.add('ticket-details-variant-btn--selected');
          firstBtn.setAttribute('aria-pressed', 'true');
          setVariant(v);
        }
      }
      function onOption1Change(selectedOption1) {
        updateOption2Visibility(selectedOption1);
        if (!option2Group) {
          var v = findVariant(selectedOption1);
          if (v) setVariant(v);
          return;
        }
        var currentOption2 = getSelectedOption2();
        var v = findVariant(selectedOption1, currentOption2);
        if (v) {
          setVariant(v);
          return;
        }
        selectFirstOption2(selectedOption1);
      }

      if (option1Group) {
        option1Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var val = btn.getAttribute('data-option-value');
            if (!val || btn.classList.contains('ticket-details-variant-btn--selected')) return;
            option1Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
              b.classList.remove('ticket-details-variant-btn--selected');
              b.removeAttribute('aria-pressed');
            });
            btn.classList.add('ticket-details-variant-btn--selected');
            btn.setAttribute('aria-pressed', 'true');
            onOption1Change(val);
          });
        });
      }
      if (option2Group) {
        option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var val = btn.getAttribute('data-option-value');
            if (!val || btn.classList.contains('ticket-details-variant-btn--selected')) return;
            if (getComputedStyle(btn).display === 'none') return;
            var opt1 = getSelectedOption1();
            var v = findVariant(opt1, val);
            if (!v) return;
            option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
              b.classList.remove('ticket-details-variant-btn--selected');
              b.removeAttribute('aria-pressed');
            });
            btn.classList.add('ticket-details-variant-btn--selected');
            btn.setAttribute('aria-pressed', 'true');
            setVariant(v);
          });
        });
      }

      var sel1 = getSelectedOption1();
      if (sel1) updateOption2Visibility(sel1);
    });
  }

  function initTicketDetails() {
    initTicketDetailsQty();
    initTicketDetailsVariant();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTicketDetails);
  } else {
    initTicketDetails();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticket-details"] && !Shopify.designMode) return;
  try {
    
  function initTicketDetailsQty() {
    var qtyContainers = document.querySelectorAll('.ticket-details-qty');
    qtyContainers.forEach(function (container) {
      var minusBtn = container.querySelector('.td-minus');
      var plusBtn = container.querySelector('.td-plus');
      var input = container.querySelector('.td-qty-value');
      if (!minusBtn || !plusBtn || !input) return;
      minusBtn.addEventListener('click', function () {
        var currentVal = parseInt(input.value, 10) || 1;
        if (currentVal > 1) input.value = currentVal - 1;
      });
      plusBtn.addEventListener('click', function () {
        var currentVal = parseInt(input.value, 10) || 1;
        input.value = currentVal + 1;
      });
    });
  }

  /* Date (option1) dulu, lalu Ticket type (option2). Harga & variant id mengikuti pilihan. */
  function initTicketDetailsVariant() {
    document.querySelectorAll('.ticket-details-purchase').forEach(function (purchase) {
      var optionsRoot = purchase.querySelector('.ticket-details-options');
      if (!optionsRoot) return;
      var scriptEl = purchase.querySelector('.ticket-details-variants-json');
      var variants = [];
      if (scriptEl) {
        try {
          variants = JSON.parse(scriptEl.textContent);
        } catch (e) {}
      }
      var priceEl = purchase.querySelector('.ticket-details-price');
      var form = purchase.querySelector('form[action*="/cart/add"]') || purchase.querySelector('form');
      var hiddenId = form ? form.querySelector('input[name="id"]') : null;
      if (!priceEl || !hiddenId) return;

      var option1Group = purchase.querySelector('.ticket-details-option1');
      var option2Group = purchase.querySelector('.ticket-details-option2');

      function getSelectedOption1() {
        if (!option1Group) return null;
        var btn = option1Group.querySelector('.ticket-details-variant-btn--selected');
        return btn ? btn.getAttribute('data-option-value') : null;
      }
      function getSelectedOption2() {
        if (!option2Group) return null;
        var btn = option2Group.querySelector('.ticket-details-variant-btn--selected');
        return btn ? btn.getAttribute('data-option-value') : null;
      }
      function findVariant(opt1, opt2) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.option1 === opt1 && (opt2 === undefined || v.option2 === opt2)) return v;
        }
        return null;
      }
      function setVariant(variant) {
        if (!variant) return;
        hiddenId.value = variant.id;
        priceEl.textContent = variant.price_formatted;
        priceEl.setAttribute('data-unit-price', variant.price);
        var compareEl = purchase.querySelector('[data-compare-price]');
        if (compareEl) {
          if (variant.compare_at_price != null && variant.compare_at_price > variant.price && variant.compare_at_price_formatted) {
            compareEl.textContent = variant.compare_at_price_formatted;
            compareEl.style.display = '';
          } else {
            compareEl.textContent = '';
            compareEl.style.display = 'none';
          }
        }
        updatePurchaseState(variant);
      }
      function updatePurchaseState(variant) {
        if (!form || !variant) return;
        var soldOut = !variant.available;
        var submitBtn = form.querySelector('.ticket-details-btn');
        var qtyWrap = form.querySelector('.ticket-details-qty');
        var purchaseRoot = form.closest('.ticket-details-purchase');
        if (purchaseRoot) {
          purchaseRoot.classList.toggle('ticket-details-purchase--sold-out', soldOut);
        }
        if (submitBtn) {
          var defaultLabel = submitBtn.getAttribute('data-default-label') || 'Buy now';
          var soldOutLabel = submitBtn.getAttribute('data-sold-out-label') || 'Sold out';
          submitBtn.disabled = soldOut;
          if (soldOut) {
            submitBtn.classList.add('ticket-details-btn--sold-out');
            submitBtn.textContent = soldOutLabel;
            submitBtn.setAttribute('aria-disabled', 'true');
          } else {
            submitBtn.classList.remove('ticket-details-btn--sold-out');
            submitBtn.textContent = defaultLabel;
            submitBtn.removeAttribute('aria-disabled');
          }
        }
        if (qtyWrap) {
          qtyWrap.hidden = soldOut;
          qtyWrap.style.display = soldOut ? 'none' : '';
        }
      }
      function updateOption2Visibility(selectedOption1) {
        if (!option2Group) return;
        var validOption2 = [];
        var soldOutMap = {};
        variants.forEach(function (v) {
          if (v.option1 === selectedOption1) {
            if (validOption2.indexOf(v.option2) === -1) validOption2.push(v.option2);
            if (soldOutMap[v.option2] === undefined) soldOutMap[v.option2] = true;
            if (v.available) soldOutMap[v.option2] = false;
          }
        });
        option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          var show = validOption2.indexOf(val) !== -1;
          btn.style.display = show ? '' : 'none';
          var isSoldOut = show ? soldOutMap[val] === true : false;
          btn.classList.toggle('ticket-details-variant-btn--sold-out', isSoldOut);
          btn.toggleAttribute('disabled', isSoldOut);
          if (isSoldOut) {
            btn.setAttribute('data-option-sold-out', 'true');
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.setAttribute('data-option-sold-out', 'false');
            btn.removeAttribute('aria-disabled');
          }
          if (!show) {
            btn.classList.remove('ticket-details-variant-btn--selected');
            btn.removeAttribute('aria-pressed');
          }
        });
      }
      function selectFirstOption2(selectedOption1) {
        if (!option2Group) {
          var v = findVariant(selectedOption1);
          if (v) setVariant(v);
          return;
        }
        var firstBtn = null;
        option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
          if (getComputedStyle(b).display !== 'none') firstBtn = firstBtn || b;
        });
        if (!firstBtn) return;
        var opt2 = firstBtn.getAttribute('data-option-value');
        var v = findVariant(selectedOption1, opt2);
        if (v) {
          option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
            b.classList.remove('ticket-details-variant-btn--selected');
            b.removeAttribute('aria-pressed');
          });
          firstBtn.classList.add('ticket-details-variant-btn--selected');
          firstBtn.setAttribute('aria-pressed', 'true');
          setVariant(v);
        }
      }

      /* Saat ganti Date: pertahankan Ticket type yang sekarang jika masih ada untuk date baru; kalau tidak, pilih opsi pertama. */
      function onOption1Change(selectedOption1) {
        updateOption2Visibility(selectedOption1);
        if (!option2Group) {
          var v = findVariant(selectedOption1);
          if (v) setVariant(v);
          return;
        }
        var currentOption2 = getSelectedOption2();
        var v = findVariant(selectedOption1, currentOption2);
        if (v) {
          setVariant(v);
          return;
        }
        selectFirstOption2(selectedOption1);
      }

      if (option1Group) {
        option1Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var val = btn.getAttribute('data-option-value');
            if (!val || btn.classList.contains('ticket-details-variant-btn--selected')) return;
            if (btn.disabled || btn.getAttribute('data-option-sold-out') === 'true') return;
            option1Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
              b.classList.remove('ticket-details-variant-btn--selected');
              b.removeAttribute('aria-pressed');
            });
            btn.classList.add('ticket-details-variant-btn--selected');
            btn.setAttribute('aria-pressed', 'true');
            onOption1Change(val);
          });
        });
      }
      if (option2Group) {
        option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var val = btn.getAttribute('data-option-value');
            if (!val || btn.classList.contains('ticket-details-variant-btn--selected')) return;
            if (getComputedStyle(btn).display === 'none') return;
            if (btn.disabled || btn.getAttribute('data-option-sold-out') === 'true') return;
            var opt1 = getSelectedOption1();
            var v = findVariant(opt1, val);
            if (!v) return;
            option2Group.querySelectorAll('.ticket-details-variant-btn').forEach(function (b) {
              b.classList.remove('ticket-details-variant-btn--selected');
              b.removeAttribute('aria-pressed');
            });
            btn.classList.add('ticket-details-variant-btn--selected');
            btn.setAttribute('aria-pressed', 'true');
            setVariant(v);
          });
        });
      }

      /* Initial: sembunyikan option2 yang tidak valid untuk option1 yang terpilih */
      var sel1 = getSelectedOption1();
      if (sel1) updateOption2Visibility(sel1);
      var initVariant = findVariant(getSelectedOption1(), getSelectedOption2());
      if (initVariant) updatePurchaseState(initVariant);
    });
  }

  function initTicketDetails() {
    initTicketDetailsQty();
    initTicketDetailsVariant();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTicketDetails);
  } else {
    initTicketDetails();
  }

  } catch(e) { console.error(e); }
})();
})();
